import(/* webpackMode: "eager", webpackExports: ["LoginForm"] */ "/home/bdeh8989/dev.ecole-st-augustin.fr/v2/app/components/auth/login-form.tsx");
